let ManageProperties = {
    store: {
        namespaced: true
    },
    components: {},
    api: {}
};